import { useQuery } from "@tanstack/react-query";
import { qk } from "../../lib/queryKeys";
import { getJson } from "../../lib/http";

export interface DashboardCounts {
  units: number;
  trailers: number;
  devices: number;
  drivers: number;
  geofences: number;
  routes: number;
  trips: number;
  groups: number;
  pointOfInterests: number;
  trackingLinks: number;
  trackingReplays: number;
  sessions: number;
  notifications: number;
  avisos: number;
  users: number;
  statuses: number;
  roles: number;
}

interface CountsResponse {
  data: Partial<DashboardCounts>;
}

export function useDashboardCounts(companyId: string | null) {
  const roleId = localStorage.getItem("userRoleId") || "";
  return useQuery({
    queryKey: qk.counts(companyId),
    queryFn: ({ signal }) =>
      getJson<CountsResponse>("/dashboardCounts", { roleId }, { signal }).then(
        (res) => res.data ?? {},
      ),
  });
}
